module.exports = __webpack_public_path__ + "static/media/pgc.a769c027.png";